import { Button, Input, TextField } from "@mui/material";
import styled from "styled-components";

const SubmitBtn = styled(Button)`
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 48px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
  transition: all 0.3s ease;
  text-transform: none;
  
  &:hover {
    background: linear-gradient(135deg, #5558e3 0%, #7c3aed 100%);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 15px;
  }
`;
const TextInput = styled(TextField)`
  width: 100%;
  max-width: 400px;
  
  & .MuiOutlinedInput-root {
    height: 56px;
    border-radius: 12px;
    background: #f8fafc;
    border: 2px solid #e2e8f0;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #cbd5e1;
      background: #ffffff;
    }
    
    &.Mui-focused {
      border-color: #6366f1;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
    }
  }
  
  & .MuiOutlinedInput-input {
    padding: 16px 20px;
    font-size: 16px;
    color: #1e293b;
    
    &::placeholder {
      color: #94a3b8;
      opacity: 1;
    }
  }
  
  @media (max-width: 480px) {
    max-width: 100%;
    
    & .MuiOutlinedInput-root {
      height: 52px;
    }
    
    & .MuiOutlinedInput-input {
      padding: 14px 18px;
      font-size: 15px;
    }
  }
`;
const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  display: block;
  letter-spacing: 0.025em;
`;
const CustomBtn = styled(Button)`
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 48px;
  background: linear-gradient(135deg, #64748b 0%, #475569 100%);
  color: white;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(100, 116, 139, 0.2);
  transition: all 0.3s ease;
  text-transform: none;
  
  &:hover {
    background: linear-gradient(135deg, #475569 0%, #334155 100%);
    box-shadow: 0 6px 20px rgba(100, 116, 139, 0.3);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 14px;
  }
`;
export { Label, TextInput, SubmitBtn, CustomBtn };
